export enum MentionFinderPopupAlignment {
    Top,
    Bottom,
}
